import React from "react";
import dayjs from "dayjs";

import { Dialog, DialogContent, DialogContentText, Box, Button, RadioGroup, FormControlLabel, Radio } from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useUtilityContext } from "../../../utility-provider";
import { setApprovalStatus } from "../../../features/approval5mcutSlice";
import { apiRequest, postPython } from "../../../api/ApiCall";
import { useRouteLoaderData } from "react-router-dom";
import MessageDialog from "../../components/MessageDialog";
import { LOCAL_CONSTANT } from "../../Const";
import { mailDetail } from "../../mailTemplate";
import { getStaffNoList } from "../../mailFunction";
import { staffName } from "../../Common";
import { userLogging } from "../../../utility/firestore";
import { useUserContext } from "../../../user-provider";
import { encryptQueryParam } from "../../../utility/util";

export interface approval5mcutModalProps {
    props: {
        open: boolean;
        handleModal: any;
        planAreaId: string | null;
        childPlanAreaId: string;
        childLocation: string;
        branch: string | null;
        userData: any;
        planAreaInfoData: any;
    };
}

const Approval5mcutModal: React.FC<approval5mcutModalProps> = ({ props }) => {
    const dispatch = useAppDispatch();
    const utilityCtx = useUtilityContext();
    const user = useUserContext();

    const [open, setOpen] = React.useState(false);

    const objApproval5mcut = useAppSelector((state) => state.approval5mcut.approvalStatus);

    const objStatusLog = useAppSelector((state) => state.longPage.statusLog);
    const cover = useAppSelector((state) => state.cover.obj);

    const objParentLocationBase = useAppSelector((state) => state.approval5mcut.parentLocationBase);
    const objParent5mcut = useAppSelector((state) => state.approval5mcut.parent5mcut);
    const objParentMarketCut = useAppSelector((state) => state.approval5mcut.parentMarketCut);
    const objChild5mcut = useAppSelector((state) => state.approval5mcut.child5mcut);
    const objChildMarketCut = useAppSelector((state) => state.approval5mcut.childMarketCut);
    const hasChild = useAppSelector((state) => state.approval5mcut.hasChild);
    const objParentLocationCover = useAppSelector((state) => state.approval5mcut.parentLocationCover);
    const objChildLocationCover = useAppSelector((state) => state.approval5mcut.childLocationCover);

    const [message, setMessage] = React.useState<string>("");
    const [messageDialogOpen, setMessageDialogOpen] = React.useState<boolean>(false);
    const [hasButton, setHasButton] = React.useState<boolean>(false);
    const [regist, setRegist] = React.useState<boolean>(false);

    React.useEffect(() => {
        setOpen(props.open);
        let fiveMeters = "";
        let marketCut = "";
        let childFiveMeters = "";
        let childMarketCut = "";
        if (props.open) {
            if (["D004", "D005", "D007", "D008"].includes(objParentLocationBase.task_id)) {
                if (objParentLocationBase.task_id === "D004") {
                    if (objParent5mcut.approval_research_mgr_flag === "1") {
                        fiveMeters = "1";
                    }
                    if (objParentMarketCut.approval_research_mgr_flag === "1") {
                        marketCut = "1";
                    }
                    if (objChild5mcut.approval_research_mgr_flag === "1") {
                        childFiveMeters = "1";
                    }
                    if (objChildMarketCut.approval_research_mgr_flag === "1") {
                        childMarketCut = "1";
                    }
                } else if (objParentLocationBase.task_id === "D005") {
                    if (objParent5mcut.approval_research_gm_flag === "1") {
                        fiveMeters = "1";
                    }
                    if (objParentMarketCut.approval_research_gm_flag === "1") {
                        marketCut = "1";
                    }
                    if (objChild5mcut.approval_research_gm_flag === "1") {
                        childFiveMeters = "1";
                    }
                    if (objChildMarketCut.approval_research_gm_flag === "1") {
                        childMarketCut = "1";
                    }
                } else if (objParentLocationBase.task_id === "D007") {
                    if (objParent5mcut.approval_mgr_flag === "1") {
                        fiveMeters = "1";
                    }
                    if (objParentMarketCut.approval_mgr_flag === "1") {
                        marketCut = "1";
                    }
                    if (objChild5mcut.approval_mgr_flag === "1") {
                        childFiveMeters = "1";
                    }
                    if (objChildMarketCut.approval_mgr_flag === "1") {
                        childMarketCut = "1";
                    }
                } else if (objParentLocationBase.task_id === "D008") {
                    if (objParent5mcut.approval_gm_flag === "1") {
                        fiveMeters = "1";
                    }
                    if (objParentMarketCut.approval_gm_flag === "1") {
                        marketCut = "1";
                    }
                    if (objChild5mcut.approval_gm_flag === "1") {
                        childFiveMeters = "1";
                    }
                    if (objChildMarketCut.approval_gm_flag === "1") {
                        childMarketCut = "1";
                    }
                }
                dispatch(
                    setApprovalStatus({
                        ...objApproval5mcut,
                        fiveMeters: fiveMeters,
                        marketCut: marketCut,
                        childFiveMeters: childFiveMeters,
                        childMarketCut: childMarketCut,
                    })
                );
            }
        }
    }, [props.open]);

    const handleClose = () => {
        dispatch(
            setApprovalStatus({
                ...objApproval5mcut,
                fiveMeters: "",
                marketCut: "",
                confirm: "",
                childFiveMeters: "",
                childMarketCut: "",
            })
        );

        props.handleModal(regist);
    };

    const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>, labelName: string) => {
        dispatch(setApprovalStatus({ ...objApproval5mcut, [labelName]: e.target.value }));
    };

    const handleDisabled = () => {
        let disabled = false;
        if (!hasChild) {
            if (objParent5mcut.cut_survey === "1" && objApproval5mcut.fiveMeters === "") {
                disabled = true;
            }

            if (objParentMarketCut.cut_market === "1" && objApproval5mcut.marketCut === "") {
                disabled = true;
            }

            if (objParentLocationBase.task_id === "D004" && objApproval5mcut.confirm === "") {
                disabled = true;
            }
        } else {
            if (
                (objParent5mcut.cut_survey === "1" && objApproval5mcut.fiveMeters === "") ||
                (objChild5mcut.cut_survey === "1" && objApproval5mcut.childFiveMeters === "") ||
                (objParentMarketCut.cut_market === "1" && objApproval5mcut.marketCut === "") ||
                (objChildMarketCut.cut_market === "1" && objApproval5mcut.childMarketCut === "")
            ) {
                disabled = true;
            }

            if (objParentLocationBase.task_id === "D004" && objApproval5mcut.confirm === "") {
                disabled = true;
            }
        }

        return disabled;
    };

    const onRegist = () => {
        (async () => {
            try {
                if (utilityCtx.showSpinner) {
                    utilityCtx.showSpinner();
                }
                // メッセージモーダル表示
                setHasButton(false);
                setMessage("承認中です");
                setMessageDialogOpen(true);
                const managerName = props.userData.user_name;
                let department = "";
                const staffMasterObj = localStorage.getItem("staffMaster");
                if (staffMasterObj !== null) {
                    const jsonStaffMasterObj = JSON.parse(staffMasterObj);
                    jsonStaffMasterObj.map((row: any) => {
                        if (row.department_code_oa === props.userData.department_code_OA) {
                            department = row.department_name_oa;
                        }
                    });
                }
                const pattern = approvalPattern();
                const urlQueryParam = `planAreaId=${props.planAreaId}&branch=${props.branch}`;
                const encryptedQueryParam = await encryptQueryParam(urlQueryParam);

                // 子調査書がある場合先に更新
                if (hasChild) {
                    const childPaythonParams = {
                        mode: "regist",
                        endPoint: "/make-iner",
                        query: {
                            prop_site_no: props.childPlanAreaId,
                            branch: props.branch,
                            managerName: managerName,
                            department: department,
                        },
                    };
                    const childResult = await postPython(childPaythonParams);
                    if (childResult.data.data.inei_file_path) {
                        await approvalMain({
                            planAreaId: props.planAreaId,
                            branch: props.branch,
                            objApproval5mcut: objApproval5mcut,
                            department: department,
                            inei_file_path: childResult.data.data.inei_file_path,
                            target: "child",
                            target_plan_area_id: props.childPlanAreaId,
                            pattern: pattern,
                            fiveMeters: objApproval5mcut.childFiveMeters,
                            marketCut: objApproval5mcut.childMarketCut,
                            urlQueryParam: encryptedQueryParam
                        });
                    }
                }

                const paythonParams = {
                    mode: "regist",
                    endPoint: "/make-iner",
                    query: {
                        prop_site_no: props.planAreaId,
                        branch: props.branch,
                        managerName: managerName,
                        department: department,
                    },
                };
                const result = await postPython(paythonParams);
                if (result.data.data.inei_file_path) {
                    await approvalMain({
                        planAreaId: props.planAreaId,
                        branch: props.branch,
                        objApproval5mcut: objApproval5mcut,
                        department: department,
                        inei_file_path: result.data.data.inei_file_path,
                        target: "parent",
                        target_plan_area_id: props.planAreaId,
                        pattern: pattern,
                        fiveMeters: objApproval5mcut.fiveMeters,
                        marketCut: objApproval5mcut.marketCut,
                        urlQueryParam: encryptedQueryParam
                    });
                }

                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
                setRegist(true);
                setHasButton(true);
                setMessage("承認しました");
            } catch (e) {
                setRegist(false);
                console.log(e);
                setHasButton(true);
                setMessage("容認に失敗しました");
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    const approvalMain = (param: any) => {
        const params = {
            mode: "regist",
            endPoint: "/location/Reception/v1/approval5mcut",
            query: {
                plan_area_id: param.planAreaId,
                branch: param.branch,
                confirm: param.objApproval5mcut.confirm,
                pattern: param.pattern,
                fiveMeters: param.fiveMeters,
                marketCut: param.marketCut,
                user: props.userData.staff_number,
                department: param.department,
                date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                stamp: param.inei_file_path,
                detail: {},
                target: param.target,
                target_plan_area_id: param.target_plan_area_id,
            },
        };
        const staffMasterObj = localStorage.getItem("staffMaster");
        let staffNoList: any = [];
        let titleDetail = "";
        let confirmationPerson = "";
        let mailTemplate = "";
        let mailDetailParam: any = {};
        let hasMail = false;
        if (param.target === "parent") {
            // 親調査書のみメール送信
            if (objParent5mcut.cut_survey === "1" && objParentMarketCut.cut_market === "1") {
                titleDetail = LOCAL_CONSTANT.LABEL.location5mCutMarketCutApproval;
            } else if (objParent5mcut.cut_survey === "1") {
                titleDetail = LOCAL_CONSTANT.LABEL.location5mCutApproval;
            } else if (objParentMarketCut.cut_market === "1") {
                titleDetail = LOCAL_CONSTANT.LABEL.marketCutApproval;
            }
            if (["1"].includes(param.pattern)) {
                // 差戻無し
                if (["D004"].includes(objParentLocationBase.task_id) && param.objApproval5mcut.confirm === "1") {
                    if (staffMasterObj !== null) {
                        staffNoList = getStaffNoList("requestEmail_5mOutsideMarketCut_D004", {
                            staffMasterObj: staffMasterObj,
                        });
                    }
                    confirmationPerson = props.userData.user_name;
                    mailTemplate = "requestEmail_5mOutsideMarketCut";
                    hasMail = true;
                } else if (["D007"].includes(objParentLocationBase.task_id)) {
                    staffNoList = getStaffNoList("requestEmail_5mOutsideMarketCut_D007", {
                        staffMasterObj: staffMasterObj,
                        planAreaInfoData: props.planAreaInfoData,
                    });
                    const objResult: any = objStatusLog?.find((log: any) => {
                        return log.before_task_id === "D002" && log.after_task_id === "D004";
                    });
                    confirmationPerson = staffName(objResult?.update_stuff_number);
                    mailTemplate = "requestEmail_5mOutsideMarketCut";
                    hasMail = true;
                }
                if (hasMail) {
                    mailDetailParam = {
                        survey_name: cover.survey_name,
                        titleDetail: titleDetail,
                        url: `${process.env.REACT_APP_HOST}/approval-5mcut?${param.urlQueryParam}`,
                        rfc: cover.survey_creator,
                        confirmationPerson: confirmationPerson,
                        type: "01",
                        staffNoList: staffNoList,
                        plan_area_id: param.planAreaId,
                        branch: param.branch,
                        notficationType: "01",
                    };
                }
            } else if (["0"].includes(param.pattern)) {
                // 差戻あり
                if (["D004", "D005", "D007", "D008"].includes(objParentLocationBase.task_id)) {
                    staffNoList = getStaffNoList("returnEmail_5mOutsideMarketcut", {
                        userData: props.userData,
                    });
                    const objResult: any = objStatusLog?.find((log: any) => {
                        return log.before_task_id === "D002" && log.after_task_id === "D004";
                    });
                    confirmationPerson = staffName(objResult?.update_stuff_number);
                    mailTemplate = "returnEmail_5mOutsideMarketcut";
                    hasMail = true;
                    mailDetailParam = {
                        survey_name: cover.survey_name,
                        titleDetail: titleDetail,
                        operator: props.userData.user_name,
                        returnedItems: titleDetail,
                        rfc: cover.survey_creator,
                        confirmationPerson: confirmationPerson,
                        type: "01",
                        staffNoList: staffNoList,
                        plan_area_id: param.planAreaId,
                        branch: param.branch,
                        notficationType: "01",
                    };
                }
            }
            if (hasMail) {
                params.query.detail = mailDetail(mailTemplate, mailDetailParam);
            }
        }

        userLogging(LOCAL_CONSTANT.FUNCTION_NAME.APPROVAL_TRAFFIC_5MCUT, params, user);
        apiRequest(params);
    };

    const approvalPattern = () => {
        let approval = "1";
        if (hasChild) {
            // 子調査書有り
            if (objApproval5mcut.fiveMeters === "0" || objApproval5mcut.marketCut === "0" || objApproval5mcut.childFiveMeters === "0" || objApproval5mcut.childMarketCut === "0") {
                // 一つでも差戻がある場合
                approval = "0";
            }
        } else {
            if (objApproval5mcut.fiveMeters === "0" || objApproval5mcut.marketCut === "0") {
                // 一つでも差戻がある場合
                approval = "0";
            }
        }

        return approval;
    };

    const closeMessageDialog = () => {
        handleClose();
        setMessage("");
        setHasButton(false);
        setMessageDialogOpen(false);
    };

    return (
        <Box>
            <Dialog
                open={open}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                sx={{
                    display: messageDialogOpen ? "none" : "block",
                }}
            >
                <DialogContent
                    sx={{
                        margin: "10px 20px",
                    }}
                >
                    {hasChild === true && <Box sx={{ margin: "10px 0", backgroundColor: "#ffa500", fontWeight: "bold", textAlign: "center" }}>{`B店承認（${objParentLocationCover.survey_name}：${props.planAreaId}）`}</Box>}
                    <Box sx={{ display: objParent5mcut.cut_survey === "1" ? "block" : "none" }}>
                        <DialogContentText id="alert-dialog-slide-description" sx={{ whiteSpace: "pre-wrap", textAlign: "center" }}>
                            「5m外」を承認しますか
                        </DialogContentText>
                        <RadioGroup row onChange={(e) => handleRadioChange(e, "fiveMeters")} value={objApproval5mcut.fiveMeters} sx={{ justifyContent: "center" }}>
                            <FormControlLabel value={"1"} control={<Radio />} label={"承認"} />
                            <FormControlLabel value={"0"} control={<Radio />} label={"差戻"} />
                        </RadioGroup>
                    </Box>
                    <Box sx={{ display: objParentMarketCut.cut_market === "1" ? "block" : "none" }}>
                        <DialogContentText id="alert-dialog-slide-description" sx={{ whiteSpace: "pre-wrap", textAlign: "center" }}>
                            「商圏カット」を承認しますか
                        </DialogContentText>
                        <RadioGroup row onChange={(e) => handleRadioChange(e, "marketCut")} value={objApproval5mcut.marketCut} sx={{ justifyContent: "center" }}>
                            <FormControlLabel value={"1"} control={<Radio />} label={"承認"} />
                            <FormControlLabel value={"0"} control={<Radio />} label={"差戻"} />
                        </RadioGroup>
                    </Box>
                    {hasChild === true && <Box sx={{ margin: "10px 0", backgroundColor: "#ffa500", fontWeight: "bold", textAlign: "center" }}>{`S店承認（${objChildLocationCover.survey_name}：${props.childLocation}）`}</Box>}
                    {hasChild && (
                        <Box sx={{ display: objChild5mcut.cut_survey === "1" ? "block" : "none" }}>
                            <DialogContentText id="alert-dialog-slide-description" sx={{ whiteSpace: "pre-wrap", textAlign: "center" }}>
                                「5m外」を承認しますか
                            </DialogContentText>
                            <RadioGroup row onChange={(e) => handleRadioChange(e, "childFiveMeters")} value={objApproval5mcut.childFiveMeters} sx={{ justifyContent: "center" }}>
                                <FormControlLabel value={"1"} control={<Radio />} label={"承認"} />
                                <FormControlLabel value={"0"} control={<Radio />} label={"差戻"} />
                            </RadioGroup>
                        </Box>
                    )}
                    {hasChild && (
                        <Box sx={{ display: objChildMarketCut.cut_market === "1" ? "block" : "none" }}>
                            <DialogContentText id="alert-dialog-slide-description" sx={{ whiteSpace: "pre-wrap", textAlign: "center" }}>
                                「商圏カット」を承認しますか
                            </DialogContentText>
                            <RadioGroup row onChange={(e) => handleRadioChange(e, "childMarketCut")} value={objApproval5mcut.childMarketCut} sx={{ justifyContent: "center" }}>
                                <FormControlLabel value={"1"} control={<Radio />} label={"承認"} />
                                <FormControlLabel value={"0"} control={<Radio />} label={"差戻"} />
                            </RadioGroup>
                        </Box>
                    )}
                    <Box sx={{ display: objParentLocationBase.task_id === "D004" ? "block" : "none" }}>
                        <DialogContentText id="alert-dialog-slide-description" sx={{ whiteSpace: "pre-wrap" }}>
                            RR GM確認が必要ですか
                        </DialogContentText>
                        <RadioGroup row onChange={(e) => handleRadioChange(e, "confirm")} value={objApproval5mcut.confirm} sx={{ justifyContent: "center" }}>
                            <FormControlLabel value={"1"} control={<Radio />} label={"必要"} />
                            <FormControlLabel value={"0"} control={<Radio />} label={"不要"} />
                        </RadioGroup>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-around" }}>
                        <Box sx={{ textAlign: "center", margin: "10px" }}>
                            <Button variant="outlined" color="error" size="small" onClick={handleClose}>
                                キャンセル
                            </Button>
                        </Box>
                        <Box sx={{ textAlign: "center", margin: "10px" }}>
                            <Button variant="contained" color="success" size="small" disabled={handleDisabled()} onClick={onRegist}>
                                送信
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
            <MessageDialog
                props={{
                    open: messageDialogOpen,
                    handleModal: closeMessageDialog,
                    body: message,
                    hasButton: hasButton,
                    buttonBody: LOCAL_CONSTANT.LABEL.CLOSE,
                }}
            />
        </Box>
    );
};

export default Approval5mcutModal;
